<!--
  Example Usage:
  <FormLabel for='username' class='caps'>Enter Username</FormLabel>
-->
<script>
  let {
    /** @type {string} additional CSS classes to be attached to the label (use sparingly) */
    class: css_class,
    /** @type {string} id of labelled item */
    for: for_id,
    children,
    disabled,
  } = $props();
</script>

<label 
  for={for_id} 
  class='form-label text-control text-2 {css_class} {(disabled || !for_id) ? 'disabled' : ''}'
>
  {@render children()}
</label>

<style lang='postcss'>
  .form-label {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-block: var(--input-block-spacing);
    padding-inline: var(--input-inline-spacing);
    min-height: var(--input-min-height);
    &.disabled {
      pointer-events: none;
    }
  }
  :global(.flex-column > .form-label){
    padding-inline: 0;
    min-height: inherit;
  }
</style>